import SearchBar from 'components/Autosuggest/Autosuggest';
import SubscriptionTypeDropdown from 'components/SubscriptionTypeDropdown';
import React, { useState } from 'react';
import { createUserSubscription, searchUserByName } from 'services';
import { DATE_FORMATS, formatDate, showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const AddSubscriptionModal = props => {
  const [note, setNote] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [user, setUser] = useState<Record<string, any>>({});
  const [userId, setUserId] = useState<string>('');
  const [stripeSubscriptionId, setStripeSubscriptionId] = useState<string>('');
  const [subscriptionTypeId, setSubscriptionTypeId] = useState<string>('');
  const [status, setStatus] = useState<string>('');
  const [lastBoxSentAt, setLastBoxSentAt] = useState<string | null>();
  const [nextBoxWillBeSentAt, setNextBoxWillBeSentAt] = useState<string | null>();
  const [startDate, setStartDate] = useState<string | null>();
  const [currentPeriodStart, setCurrentPeriodStart] = useState<string | null>();
  const [currentPeriodEnd, setCurrentPeriodEnd] = useState<string | null>();
  const {
    toggleModal,
    onSuccess,
  } = props;

  const createSubscriptionFn = async () => {
    setLoading(true);
    const data: Record<string, any> = {
      id: userId,
      stripeSubscriptionId,
      subscriptionTypeId,
      status,
      lastBoxSentAt,
      nextBoxWillBeSentAt,
      startDate,
      currentPeriodStart,
      currentPeriodEnd,
    };
    try {
      await createUserSubscription(data);
      showSuccess(`User subscription created successfully`);
      onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleUserNameChange = (username: string) => {
    if (!username) {
      setUser({});
      setUserId('');
    } else {
      // eslint-disable-next-line @typescript-eslint/camelcase
      setUser({ ...user, full_name: username });
    }
  };

  const handleUserSelect = (suggestion: Record<string, any>) => {
    setUser(suggestion);
    setUserId(suggestion.objectId);
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>User Subscription</div>
            <div className={styles['modal-title']}>Add User Subscription</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>User</div>
            <div className={styles['autosuggest-input']}>
              <SearchBar
                isUser={true}
                value={user.full_name || ''}
                // eslint-disable-next-line @typescript-eslint/camelcase
                setValue={handleUserNameChange}
                searchAPI={searchUserByName}
                searchAPIParamKey={'searchTerm'}
                onSuggestionClicked={handleUserSelect}
              />
            </div>
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Stripe Subscription ID</div>
            <input
              disabled={loading}
              className={'form-control'}
              value={stripeSubscriptionId}
              onChange={e => setStripeSubscriptionId(e.target.value)}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Subscription Type</div>
            <SubscriptionTypeDropdown
              disabled={loading}
              value={subscriptionTypeId}
              onChange={setSubscriptionTypeId}
            />
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Status</div>
            <select value={status} onChange={e => setStatus(e.target.value)} className={'form-control'}>
              <option hidden={!!status} value={'default'}>Select a status</option>
              <option value={'active'}>ACTIVE</option>
              <option value={'canceled'}>CANCELED</option>
              <option value={'cancelled'}>CANCELLED</option>
              <option value={'hold'}>HOLD</option>
            </select>
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Last Box Sent At</div>
            <div className={styles['date-picker']}>
              <DatePicker
                className={'form-control'}
                selected={lastBoxSentAt ? moment(lastBoxSentAt).toDate() : null}
                onChange={(e: any) => setLastBoxSentAt(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
              />
            </div>
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Next Box Will Be Sent At</div>
            <div className={styles['date-picker']}>
              <DatePicker
                className={'form-control'}
                selected={nextBoxWillBeSentAt ? moment(nextBoxWillBeSentAt).toDate() : null}
                onChange={(e: any) => setNextBoxWillBeSentAt(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
              />
            </div>
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Start Date</div>
            <div className={styles['date-picker']}>
              <DatePicker
                className={'form-control'}
                selected={startDate ? moment(startDate).toDate() : null}
                onChange={(e: any) => setStartDate(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
              />
            </div>
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Current Period Start</div>
            <div className={styles['date-picker']}>
              <DatePicker
                className={'form-control'}
                selected={currentPeriodStart ? moment(currentPeriodStart).toDate() : null}
                onChange={(e: any) => setCurrentPeriodStart(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
              />
            </div>
          </div>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Current Period End</div>
            <div className={styles['date-picker']}>
              <DatePicker
                className={'form-control'}
                selected={currentPeriodEnd ? moment(currentPeriodEnd).toDate() : null}
                onChange={(e: any) => setCurrentPeriodEnd(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
              />
            </div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className={styles['submit-button']}
            onClick={createSubscriptionFn}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSubscriptionModal;